module.exports = __webpack_public_path__ + "fonts/NespressoLucas-Med.eot?v=5f075cdf8bd8ee72a6b9e1998bb0b624";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/nespresso-lucas/NespressoLucas-Med.eot?
// module id = 661
// module chunks = 0